var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WrapBg',{attrs:{"title":"签约结果","bgImg":"chargeBg"}},[_c('div',{staticClass:"text-center text-success"},[_c('i',{staticClass:"el-icon-success",staticStyle:{"font-size":"80px","margin":"50px 0 30px"}}),_c('div',[_vm._v("签约成功")])])])}
var staticRenderFns = []

export { render, staticRenderFns }